export default __webpack_public_path__ + "static/media/UserManual.ee2df4e5.pdf";